// extracted by mini-css-extract-plugin
export default {"container":"styles_container__L4qFw","icon":"styles_icon__g0axY"};